import moment from "moment";
import { Timezones } from "@obby/constants";

export function Date__UTCDate(
  date: string,
  timezone: string = Timezones.EUROPE_LONDON
) {
  return moment.tz(date, timezone).toISOString();
}
